import { LocalStorageKey } from '../constants';

export class LocalStorageService {
  static getValue<T>(key: LocalStorageKey) {
    const stored = localStorage.getItem(key);
    return stored ? (JSON.parse(stored) as T) : undefined;
  }

  static updateValue<T>(key: LocalStorageKey, value: Partial<T>) {
    const current = LocalStorageService.getValue<T>(key) || {};
    localStorage.setItem(
      key,
      JSON.stringify({
        ...current,
        ...value,
      })
    );
  }

  static setValue<T>(key: LocalStorageKey, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static clearValue(key: LocalStorageKey) {
    localStorage.removeItem(key);
  }
}
